export enum BillingAddressFormDecision {
  Company = 'company',
  Individual = 'individual',
}
